// import React, { useState, useEffect } from 'react';
// import {
//   Form,
//   Input,
//   Select,
//   DatePicker,
//   InputNumber,
//   Button,
//   Upload,
//   Card,
//   Table,
//   Space,
//   Tag,
//   Modal,
//   message,
//   Row,
//   Col,
//   Divider,
//   Typography,
//   Spin,
// } from 'antd';
// import {
//   UploadOutlined,
//   DeleteOutlined,
//   EyeOutlined,
//   PlusOutlined,
//   FileImageOutlined,
//   FilePdfOutlined,
//   ReloadOutlined,
// } from '@ant-design/icons';
// import dayjs from 'dayjs';
// import {
//   getExpenseApi,
//   createExpenseApi,
//   updateExpenseApi,
//   deleteExpenseApi,
//   getExpenseByIdApi,
// } from '../../services/expenseApi';
// import { useParams } from 'react-router-dom';

// const { TextArea } = Input;
// const { Option } = Select;
// const { Title } = Typography;

// const AddExpensePage = () => {
//   const [form] = Form.useForm();
//   const [expenses, setExpenses] = useState([]);
//   const [fileList, setFileList] = useState([]);
//   const [viewModalVisible, setViewModalVisible] = useState(false);
//   const [selectedExpense, setSelectedExpense] = useState(null);
//   const [loading, setLoading] = useState(false);
//   const [tableLoading, setTableLoading] = useState(false);
//   const [pagination, setPagination] = useState({
//     current: 1,
//     pageSize: 10,
//     total: 0,
//   });
//   const [filters, setFilters] = useState({});
// const {companyId} = useParams()
//   // Expense categories
//   const categories = [
//     'Rent',
//     'Utilities',
//     'Inventory',
//     'Salary',
//     'Marketing',
//     'Transportation',
//     'Office Supplies',
//     'Miscellaneous',
//   ];

//   // Payment modes
//   const paymentModes = ['Cash', 'Card', 'UPI', 'Bank Transfer'];

//   // Fetch expenses on component mount and when filters/pagination change
//   useEffect(() => {
//     fetchExpenses();
//   }, [pagination.current, pagination.pageSize, filters]);

//   // Fetch all expenses
//   const fetchExpenses = async () => {
//     try {
//       setTableLoading(true);
//       const params = {
//         page: pagination.current,
//         limit: pagination.pageSize,
//         sortBy: 'date',
//         sortOrder: 'desc',
//         companyId:companyId,
//         ...filters,
//       };

//       const response = await getExpenseApi(params);
      
//       if (response?.success) {
//         setExpenses(response.data);
//         setPagination({
//           ...pagination,
//           total: response.pagination.total,
//         });
//       }
//     } catch (error) {
//       message.error('Failed to fetch expenses');
//       console.error(error);
//     } finally {
//       setTableLoading(false);
//     }
//   };

//   // Handle file upload change
//   const handleUploadChange = ({ fileList: newFileList }) => {
//     setFileList(newFileList);
//   };

//   // Before upload validation
//   const beforeUpload = (file) => {
//     const isImage = file.type.startsWith('image/');
//     const isPDF = file.type === 'application/pdf';
    
//     if (!isImage && !isPDF) {
//       message.error('You can only upload image or PDF files!');
//       return Upload.LIST_IGNORE;
//     }
    
//     const isLt5M = file.size / 1024 / 1024 < 5;
//     if (!isLt5M) {
//       message.error('File must be smaller than 5MB!');
//       return Upload.LIST_IGNORE;
//     }
    
//     return false; // Prevent auto upload
//   };

//   // Handle form submission
//   const handleSubmit = async (values) => {
//     try {
//       setLoading(true);

//       // Create FormData
//       const formData = new FormData();
//       formData.append('expenseName', values.expenseName);
//       formData.append('category', values.category);
//       formData.append('date', values.date.format('YYYY-MM-DD'));
//       formData.append('amount', values.amount);
//       formData.append('paymentMode', values.paymentMode);
      
//       if (values.notes) {
//         formData.append('notes', values.notes);
//       }
//       if(companyId) formData.append('companyId',companyId)

//       // Append files
//       fileList.forEach((file) => {
//         formData.append('attachments', file.originFileObj);
//       });

//       const response = await createExpenseApi(formData);

//       if (response.success) {
//         message.success('Expense added successfully!');
        
//         // Reset form
//         form.resetFields();
//         setFileList([]);
//         form.setFieldsValue({ date: dayjs() });
        
//         // Refresh expense list
//         fetchExpenses();
//       } else {
//         message.error(response.message || 'Failed to create expense');
//       }
//     } catch (error) {
//       message.error('Failed to create expense');
//       console.error(error);
//     } finally {
//       setLoading(false);
//     }
//   };

//   // Handle delete expense
//   const handleDelete = (id) => {
//     Modal.confirm({
//       title: 'Are you sure you want to delete this expense?',
//       content: 'This action cannot be undone.',
//       okText: 'Yes, Delete',
//       okType: 'danger',
//       cancelText: 'Cancel',
//       onOk: async () => {
//         try {
//           const response = await deleteExpenseApi(id);
          
//           if (response.success) {
//             message.success('Expense deleted successfully!');
//             fetchExpenses();
//           } else {
//             message.error(response.message || 'Failed to delete expense');
//           }
//         } catch (error) {
//           message.error('Failed to delete expense');
//           console.error(error);
//         }
//       },
//     });
//   };

//   // Handle view expense
//   const handleView = async (expense) => {
//     try {
//       setLoading(true);
//       const response = await getExpenseByIdApi(expense._id);
      
//       if (response?.success) {
//         setSelectedExpense(response.data);
//         setViewModalVisible(true);
//       } else {
//         message.error('Failed to fetch expense details');
//       }
//     } catch (error) {
//       message.error('Failed to fetch expense details');
//       console.error(error);
//     } finally {
//       setLoading(false);
//     }
//   };

//   // Handle table change (pagination, filters, sorter)
//   const handleTableChange = (newPagination, filters, sorter) => {
//     setPagination({
//       ...pagination,
//       current: newPagination.current,
//       pageSize: newPagination.pageSize,
//     });

//     // Update filters
//     const newFilters = {};
//     if (filters.category && filters.category.length > 0) {
//       newFilters.category = filters.category[0];
//     }
//     if (filters.paymentMode && filters.paymentMode.length > 0) {
//       newFilters.paymentMode = filters.paymentMode[0];
//     }
//     setFilters(newFilters);
//   };

//   // Get color for payment mode tag
//   const getPaymentModeColor = (mode) => {
//     const colors = {
//       Cash: 'green',
//       Card: 'blue',
//       UPI: 'purple',
//       'Bank Transfer': 'orange',
//     };
//     return colors[mode] || 'default';
//   };

//   // Get color for category tag
//   const getCategoryColor = (category) => {
//     const colors = {
//       Rent: 'red',
//       Utilities: 'orange',
//       Inventory: 'blue',
//       Salary: 'purple',
//       Marketing: 'cyan',
//       Transportation: 'green',
//       'Office Supplies': 'geekblue',
//       Miscellaneous: 'default',
//     };
//     return colors[category] || 'default';
//   };

//   // Table columns
//   const columns = [
//     {
//       title: 'Date',
//       dataIndex: 'date',
//       key: 'date',
//       render: (date) => dayjs(date).format('DD/MM/YYYY'),
//       sorter: true,
//       width: 120,
//     },
//     {
//       title: 'Expense Name',
//       dataIndex: 'expenseName',
//       key: 'expenseName',
//       width: 200,
//     },
//     {
//       title: 'Category',
//       dataIndex: 'category',
//       key: 'category',
//       render: (category) => (
//         <Tag color={getCategoryColor(category)}>{category}</Tag>
//       ),
//       filters: categories.map(cat => ({ text: cat, value: cat })),
//       width: 150,
//     },
//     {
//       title: 'Amount',
//       dataIndex: 'amount',
//       key: 'amount',
//       render: (amount) => `₹${amount.toLocaleString('en-IN')}`,
//       sorter: true,
//       width: 120,
//     },
//     {
//       title: 'Payment Mode',
//       dataIndex: 'paymentMode',
//       key: 'paymentMode',
//       render: (mode) => (
//         <Tag color={getPaymentModeColor(mode)}>{mode}</Tag>
//       ),
//       filters: paymentModes.map(mode => ({ text: mode, value: mode })),
//       width: 150,
//     },
//     {
//       title: 'Attachments',
//       key: 'attachments',
//       render: (_, record) => (
//         record.attachments && record.attachments.length > 0 ? (
//           <Tag color="blue">{record.attachments.length} file(s)</Tag>
//         ) : (
//           <Tag>No files</Tag>
//         )
//       ),
//       width: 120,
//     },
//     {
//       title: 'Actions',
//       key: 'actions',
//       fixed: 'right',
//       width: 120,
//       render: (_, record) => (
//         <Space>
//           <Button
//             type="link"
//             icon={<EyeOutlined />}
//             onClick={() => handleView(record)}
//           >
//             View
//           </Button>
//           <Button
//             type="link"
//             danger
//             icon={<DeleteOutlined />}
//             onClick={() => handleDelete(record._id)}
//           >
//             Delete
//           </Button>
//         </Space>
//       ),
//     },
//   ];

//   return (
//     <div style={{ padding: '24px', backgroundColor: '#f0f2f5', minHeight: '100vh' }}>
//       {/* Add Expense Form */}
//       <Card
//         title={
//           <Space>
//             <PlusOutlined />
//             <span>Add New Expense</span>
//           </Space>
//         }
//         style={{ marginBottom: 24 }}
//       >
//         <Form
//           form={form}
//           layout="vertical"
//           onFinish={handleSubmit}
//           initialValues={{
//             date: dayjs(),
//           }}
//         >
//           <Row gutter={16}>
//             <Col xs={24} sm={12} md={8}>
//               <Form.Item
//                 label="Expense Name"
//                 name="expenseName"
//                 rules={[
//                   { required: true, message: 'Please enter expense name' },
//                   { min: 3, message: 'Name must be at least 3 characters' },
//                 ]}
//               >
//                 <Input
//                   placeholder="e.g. Product Purchase, Rent"
//                   size="large"
//                 />
//               </Form.Item>
//             </Col>

//             <Col xs={24} sm={12} md={8}>
//               <Form.Item
//                 label="Expense Category"
//                 name="category"
//                 rules={[{ required: true, message: 'Please select a category' }]}
//               >
//                 <Select placeholder="Select category" size="large">
//                   {categories.map((category) => (
//                     <Option key={category} value={category}>
//                       {category}
//                     </Option>
//                   ))}
//                 </Select>
//               </Form.Item>
//             </Col>

//             <Col xs={24} sm={12} md={8}>
//               <Form.Item
//                 label="Date"
//                 name="date"
//                 rules={[{ required: true, message: 'Please select date' }]}
//               >
//                 <DatePicker
//                   style={{ width: '100%' }}
//                   size="large"
//                   format="DD/MM/YYYY"
//                 />
//               </Form.Item>
//             </Col>

//             <Col xs={24} sm={12} md={8}>
//               <Form.Item
//                 label="Amount (₹)"
//                 name="amount"
//                 rules={[
//                   { required: true, message: 'Please enter amount' },
//                   { type: 'number', min: 0.01, message: 'Amount must be greater than 0' },
//                 ]}
//               >
//                 <InputNumber
//                   style={{ width: '100%' }}
//                   size="large"
//                   prefix="₹"
//                   placeholder="0.00"
//                   formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
//                   parser={value => value.replace(/\₹\s?|(,*)/g, '')}
//                 />
//               </Form.Item>
//             </Col>

//             <Col xs={24} sm={12} md={8}>
//               <Form.Item
//                 label="Payment Mode"
//                 name="paymentMode"
//                 rules={[{ required: true, message: 'Please select payment mode' }]}
//               >
//                 <Select placeholder="Select payment mode" size="large">
//                   {paymentModes.map((mode) => (
//                     <Option key={mode} value={mode}>
//                       {mode}
//                     </Option>
//                   ))}
//                 </Select>
//               </Form.Item>
//             </Col>

//             <Col xs={24} sm={12} md={8}>
//               <Form.Item label="Attach Bill/Receipt" name="attachments">
//                 <Upload
//                   fileList={fileList}
//                   onChange={handleUploadChange}
//                   beforeUpload={beforeUpload}
//                   accept="image/*,.pdf"
//                   multiple
//                 >
//                   <Button icon={<UploadOutlined />} size="large" block>
//                     Upload Files
//                   </Button>
//                 </Upload>
//               </Form.Item>
//             </Col>

//             <Col xs={24}>
//               <Form.Item label="Notes / Description" name="notes">
//                 <TextArea
//                   rows={3}
//                   placeholder="Add any additional notes or description (optional)"
//                   maxLength={500}
//                   showCount
//                 />
//               </Form.Item>
//             </Col>
//           </Row>

//           <Form.Item>
//             <Space>
//               <Button 
//                 type="primary" 
//                 htmlType="submit" 
//                 size="large" 
//                 icon={<PlusOutlined />}
//                 loading={loading}
//               >
//                 Add Expense
//               </Button>
//               <Button
//                 size="large"
//                 onClick={() => {
//                   form.resetFields();
//                   setFileList([]);
//                   form.setFieldsValue({ date: dayjs() });
//                 }}
//               >
//                 Reset
//               </Button>
//             </Space>
//           </Form.Item>
//         </Form>
//       </Card>

//       {/* Expenses List */}
//       <Card
//         title={
//           <Space>
//             <Title level={4} style={{ margin: 0 }}>
//               Expense Records
//             </Title>
//             <Tag color="blue">{pagination.total} Total</Tag>
//           </Space>
//         }
//         extra={
//           <Button 
//             icon={<ReloadOutlined />} 
//             onClick={fetchExpenses}
//             loading={tableLoading}
//           >
//             Refresh
//           </Button>
//         }
//       >
//         <Table
//           columns={columns}
//           dataSource={expenses}
//           rowKey="_id"
//           loading={tableLoading}
//           pagination={{
//             current: pagination.current,
//             pageSize: pagination.pageSize,
//             total: pagination.total,
//             showTotal: (total) => `Total ${total} expenses`,
//             showSizeChanger: true,
//             pageSizeOptions: ['10', '20', '50', '100'],
//           }}
//           onChange={handleTableChange}
//           scroll={{ x: 1200 }}
//         />
//       </Card>

//       {/* View Modal */}
//       <Modal
//         title="Expense Details"
//         open={viewModalVisible}
//         onCancel={() => setViewModalVisible(false)}
//         footer={[
//           <Button key="close" onClick={() => setViewModalVisible(false)}>
//             Close
//           </Button>,
//         ]}
//         width={700}
//       >
//         {selectedExpense && (
//           <div>
//             <Row gutter={[16, 16]}>
//               <Col span={12}>
//                 <strong>Expense Name:</strong>
//                 <div style={{ marginTop: 8 }}>{selectedExpense.expenseName}</div>
//               </Col>
//               <Col span={12}>
//                 <strong>Category:</strong>
//                 <div style={{ marginTop: 8 }}>
//                   <Tag color={getCategoryColor(selectedExpense.category)}>
//                     {selectedExpense.category}
//                   </Tag>
//                 </div>
//               </Col>
//               <Col span={12}>
//                 <strong>Date:</strong>
//                 <div style={{ marginTop: 8 }}>
//                   {dayjs(selectedExpense.date).format('DD/MM/YYYY')}
//                 </div>
//               </Col>
//               <Col span={12}>
//                 <strong>Amount:</strong>
//                 <div style={{ marginTop: 8, fontSize: 18, color: '#1890ff' }}>
//                   ₹{selectedExpense.amount.toLocaleString('en-IN')}
//                 </div>
//               </Col>
//               <Col span={12}>
//                 <strong>Payment Mode:</strong>
//                 <div style={{ marginTop: 8 }}>
//                   <Tag color={getPaymentModeColor(selectedExpense.paymentMode)}>
//                     {selectedExpense.paymentMode}
//                   </Tag>
//                 </div>
//               </Col>
//               <Col span={24}>
//                 <Divider />
//                 <strong>Notes / Description:</strong>
//                 <div style={{ marginTop: 8, whiteSpace: 'pre-wrap' }}>
//                   {selectedExpense.notes || 'No notes available'}
//                 </div>
//               </Col>
//               {selectedExpense.attachments && selectedExpense.attachments.length > 0 && (
//                 <Col span={24}>
//                   <Divider />
//                   <strong>Attachments:</strong>
//                   <div style={{ marginTop: 12 }}>
//                     <Space direction="vertical" style={{ width: '100%' }}>
//                       {selectedExpense.attachments.map((file, index) => (
//                         <Card key={index} size="small">
//                           <Space>
//                             {file.fileType.startsWith('image/') ? (
//                               <FileImageOutlined style={{ fontSize: 24, color: '#1890ff' }} />
//                             ) : (
//                               <FilePdfOutlined style={{ fontSize: 24, color: '#ff4d4f' }} />
//                             )}
//                             <div>
//                               <div>{file.fileName}</div>
//                               <a
//                                 href={file.fileUrl}
//                                 target="_blank"
//                                 rel="noopener noreferrer"
//                                 style={{ fontSize: 12 }}
//                               >
//                                 View File
//                               </a>
//                             </div>
//                           </Space>
//                         </Card>
//                       ))}
//                     </Space>
//                   </div>
//                 </Col>
//               )}
//             </Row>
//           </div>
//         )}
//       </Modal>
//     </div>
//   );
// };

// export default AddExpensePage;


import React, { useState, useEffect } from 'react';
import {
  Form,
  Input,
  Select,
  DatePicker,
  InputNumber,
  Button,
  Upload,
  Card,
  Table,
  Space,
  Tag,
  Modal,
  message,
  Row,
  Col,
  Divider,
  Typography,
  Spin,
} from 'antd';
import {
  UploadOutlined,
  DeleteOutlined,
  EyeOutlined,
  PlusOutlined,
  FileImageOutlined,
  FilePdfOutlined,
  ReloadOutlined,
  SearchOutlined,
  FilterOutlined,
  ClearOutlined,
} from '@ant-design/icons';
import dayjs from 'dayjs';
import {
  getExpenseApi,
  createExpenseApi,
  updateExpenseApi,
  deleteExpenseApi,
  getExpenseByIdApi,
} from '../../services/expenseApi';
import { useParams } from 'react-router-dom';
import { Text } from 'lucide-react';

const { TextArea } = Input;
const { Option } = Select;
const { Title } = Typography;
const { RangePicker } = DatePicker;

const AddExpensePage = () => {
  const [form] = Form.useForm();
  const [expenses, setExpenses] = useState([]);
  const [fileList, setFileList] = useState([]);
  const [viewModalVisible, setViewModalVisible] = useState(false);
  const [selectedExpense, setSelectedExpense] = useState(null);
  const [loading, setLoading] = useState(false);
  const [tableLoading, setTableLoading] = useState(false);
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
    total: 0,
  });
  const [filters, setFilters] = useState({});
  const [searchText, setSearchText] = useState('');
  const [dateRange, setDateRange] = useState([null, null]);
  const { companyId } = useParams();

  // Expense categories
  const categories = [
    'Rent',
    'Utilities',
    'Inventory',
    'Salary',
    'Marketing',
    'Transportation',
    'Office Supplies',
    'Miscellaneous',
  ];

  // Payment modes
  const paymentModes = ['Cash', 'Card', 'UPI', 'Bank Transfer'];

  // Fetch expenses on component mount and when filters/pagination change
  useEffect(() => {
    fetchExpenses();
  }, [pagination.current, pagination.pageSize, filters, searchText, dateRange]);

  // Fetch all expenses
  const fetchExpenses = async () => {
    try {
      setTableLoading(true);
      const params = {
        page: pagination.current,
        limit: pagination.pageSize,
        sortBy: 'date',
        sortOrder: 'desc',
        companyId: companyId,
        ...filters,
      };

      // Add search parameter
      if (searchText) {
        params.search = searchText;
      }

      // Add date range parameters
      if (dateRange[0] && dateRange[1]) {
        params.startDate = dateRange[0].format('YYYY-MM-DD');
        params.endDate = dateRange[1].format('YYYY-MM-DD');
      }

      const response = await getExpenseApi(params);
      
      if (response?.success) {
        setExpenses(response.data);
        setPagination({
          ...pagination,
          total: response.pagination.total,
        });
      }
    } catch (error) {
      message.error('Failed to fetch expenses');
      console.error(error);
    } finally {
      setTableLoading(false);
    }
  };

  // Handle search
  const handleSearch = (value) => {
    setSearchText(value);
    setPagination({ ...pagination, current: 1 }); // Reset to first page
  };

  // Handle date range change
  const handleDateRangeChange = (dates) => {
    setDateRange(dates || [null, null]);
    setPagination({ ...pagination, current: 1 }); // Reset to first page
  };

  // Clear all filters
  const handleClearFilters = () => {
    setSearchText('');
    setDateRange([null, null]);
    setFilters({});
    setPagination({ ...pagination, current: 1 });
  };

  // Handle file upload change
  const handleUploadChange = ({ fileList: newFileList }) => {
    setFileList(newFileList);
  };

  // Before upload validation
  const beforeUpload = (file) => {
    const isImage = file.type.startsWith('image/');
    const isPDF = file.type === 'application/pdf';
    
    if (!isImage && !isPDF) {
      message.error('You can only upload image or PDF files!');
      return Upload.LIST_IGNORE;
    }
    
    const isLt5M = file.size / 1024 / 1024 < 5;
    if (!isLt5M) {
      message.error('File must be smaller than 5MB!');
      return Upload.LIST_IGNORE;
    }
    
    return false; // Prevent auto upload
  };

  // Handle form submission
  const handleSubmit = async (values) => {
    try {
      setLoading(true);

      // Create FormData
      const formData = new FormData();
      formData.append('expenseName', values.expenseName);
      formData.append('category', values.category);
      formData.append('date', values.date.format('YYYY-MM-DD'));
      formData.append('amount', values.amount);
      formData.append('paymentMode', values.paymentMode);
      
      if (values.notes) {
        formData.append('notes', values.notes);
      }
      if (companyId) formData.append('companyId', companyId);

      // Append files
      fileList.forEach((file) => {
        formData.append('attachments', file.originFileObj);
      });

      const response = await createExpenseApi(formData);

      if (response.success) {
        message.success('Expense added successfully!');
        
        // Reset form
        form.resetFields();
        setFileList([]);
        form.setFieldsValue({ date: dayjs() });
        
        // Refresh expense list
        fetchExpenses();
      } else {
        message.error(response.message || 'Failed to create expense');
      }
    } catch (error) {
      message.error('Failed to create expense');
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  // Handle delete expense
  const handleDelete = (id) => {
    Modal.confirm({
      title: 'Are you sure you want to delete this expense?',
      content: 'This action cannot be undone.',
      okText: 'Yes, Delete',
      okType: 'danger',
      cancelText: 'Cancel',
      onOk: async () => {
        try {
          const response = await deleteExpenseApi(id);
          
          if (response.success) {
            message.success('Expense deleted successfully!');
            fetchExpenses();
          } else {
            message.error(response.message || 'Failed to delete expense');
          }
        } catch (error) {
          message.error('Failed to delete expense');
          console.error(error);
        }
      },
    });
  };

  // Handle view expense
  const handleView = async (expense) => {
    try {
      setLoading(true);
      const response = await getExpenseByIdApi(expense._id);
      
      if (response?.success) {
        setSelectedExpense(response.data);
        setViewModalVisible(true);
      } else {
        message.error('Failed to fetch expense details');
      }
    } catch (error) {
      message.error('Failed to fetch expense details');
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  // Handle table change (pagination, filters, sorter)
  const handleTableChange = (newPagination, filters, sorter) => {
    setPagination({
      ...pagination,
      current: newPagination.current,
      pageSize: newPagination.pageSize,
    });

    // Update filters
    const newFilters = {};
    if (filters.category && filters.category.length > 0) {
      newFilters.category = filters.category[0];
    }
    if (filters.paymentMode && filters.paymentMode.length > 0) {
      newFilters.paymentMode = filters.paymentMode[0];
    }
    setFilters(newFilters);
  };

  // Get color for payment mode tag
  const getPaymentModeColor = (mode) => {
    const colors = {
      Cash: 'green',
      Card: 'blue',
      UPI: 'purple',
      'Bank Transfer': 'orange',
    };
    return colors[mode] || 'default';
  };

  // Get color for category tag
  const getCategoryColor = (category) => {
    const colors = {
      Rent: 'red',
      Utilities: 'orange',
      Inventory: 'blue',
      Salary: 'purple',
      Marketing: 'cyan',
      Transportation: 'green',
      'Office Supplies': 'geekblue',
      Miscellaneous: 'default',
    };
    return colors[category] || 'default';
  };

  // Table columns
  const columns = [
    {
      title: 'Date',
      dataIndex: 'date',
      key: 'date',
      render: (date) => dayjs(date).format('DD/MM/YYYY'),
      sorter: true,
      width: 120,
    },
    {
      title: 'Expense Name',
      dataIndex: 'expenseName',
      key: 'expenseName',
      width: 200,
    },
    {
      title: 'Category',
      dataIndex: 'category',
      key: 'category',
      render: (category) => (
        <Tag color={getCategoryColor(category)}>{category}</Tag>
      ),
      filters: categories.map(cat => ({ text: cat, value: cat })),
      width: 150,
    },
    {
      title: 'Amount',
      dataIndex: 'amount',
      key: 'amount',
      render: (amount) => `₹${amount.toLocaleString('en-IN')}`,
      sorter: true,
      width: 120,
    },
    {
      title: 'Payment Mode',
      dataIndex: 'paymentMode',
      key: 'paymentMode',
      render: (mode) => (
        <Tag color={getPaymentModeColor(mode)}>{mode}</Tag>
      ),
      filters: paymentModes.map(mode => ({ text: mode, value: mode })),
      width: 150,
    },
    {
      title: 'Attachments',
      key: 'attachments',
      render: (_, record) => (
        record.attachments && record.attachments.length > 0 ? (
          <Tag color="blue">{record.attachments.length} file(s)</Tag>
        ) : (
          <Tag>No files</Tag>
        )
      ),
      width: 120,
    },
    {
      title: 'Actions',
      key: 'actions',
      fixed: 'right',
      width: 120,
      render: (_, record) => (
        <Space>
          <Button
            type="link"
            icon={<EyeOutlined />}
            onClick={() => handleView(record)}
          >
            View
          </Button>
          <Button
            type="link"
            danger
            icon={<DeleteOutlined />}
            onClick={() => handleDelete(record._id)}
          >
            Delete
          </Button>
        </Space>
      ),
    },
  ];

  return (
    <div style={{ padding: '24px', backgroundColor: '#f0f2f5', minHeight: '100vh' }}>
      {/* Add Expense Form */}
      <Card
        title={
          <Space>
            <PlusOutlined />
            <span>Add New Expense</span>
          </Space>
        }
        style={{ marginBottom: 24 }}
      >
        <Form
          form={form}
          layout="vertical"
          onFinish={handleSubmit}
          initialValues={{
            date: dayjs(),
          }}
        >
          <Row gutter={16}>
            <Col xs={24} sm={12} md={8}>
              <Form.Item
                label="Expense Name"
                name="expenseName"
                rules={[
                  { required: true, message: 'Please enter expense name' },
                  { min: 3, message: 'Name must be at least 3 characters' },
                ]}
              >
                <Input
                  placeholder="e.g. Product Purchase, Rent"
                  size="large"
                />
              </Form.Item>
            </Col>

            <Col xs={24} sm={12} md={8}>
              <Form.Item
                label="Expense Category"
                name="category"
                rules={[{ required: true, message: 'Please select a category' }]}
              >
                <Select placeholder="Select category" size="large">
                  {categories.map((category) => (
                    <Option key={category} value={category}>
                      {category}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>

            <Col xs={24} sm={12} md={8}>
              <Form.Item
                label="Date"
                name="date"
                rules={[{ required: true, message: 'Please select date' }]}
              >
                <DatePicker
                  style={{ width: '100%' }}
                  size="large"
                  format="DD/MM/YYYY"
                />
              </Form.Item>
            </Col>

            <Col xs={24} sm={12} md={8}>
              <Form.Item
                label="Amount (₹)"
                name="amount"
                rules={[
                  { required: true, message: 'Please enter amount' },
                  { type: 'number', min: 0.01, message: 'Amount must be greater than 0' },
                ]}
              >
                <InputNumber
                  style={{ width: '100%' }}
                  size="large"
                  prefix="₹"
                  placeholder="0.00"
                  formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                  parser={value => value.replace(/\₹\s?|(,*)/g, '')}
                />
              </Form.Item>
            </Col>

            <Col xs={24} sm={12} md={8}>
              <Form.Item
                label="Payment Mode"
                name="paymentMode"
                rules={[{ required: true, message: 'Please select payment mode' }]}
              >
                <Select placeholder="Select payment mode" size="large">
                  {paymentModes.map((mode) => (
                    <Option key={mode} value={mode}>
                      {mode}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>

            <Col xs={24} sm={12} md={8}>
              <Form.Item label="Attach Bill/Receipt" name="attachments">
                <Upload
                  fileList={fileList}
                  onChange={handleUploadChange}
                  beforeUpload={beforeUpload}
                  accept="image/*,.pdf"
                  multiple
                >
                  <Button icon={<UploadOutlined />} size="large" block>
                    Upload Files
                  </Button>
                </Upload>
              </Form.Item>
            </Col>

            <Col xs={24}>
              <Form.Item label="Notes / Description" name="notes">
                <TextArea
                  rows={3}
                  placeholder="Add any additional notes or description (optional)"
                  maxLength={500}
                  showCount
                />
              </Form.Item>
            </Col>
          </Row>

          <Form.Item>
            <Space>
              <Button 
                type="primary" 
                htmlType="submit" 
                size="large" 
                icon={<PlusOutlined />}
                loading={loading}
              >
                Add Expense
              </Button>
              <Button
                size="large"
                onClick={() => {
                  form.resetFields();
                  setFileList([]);
                  form.setFieldsValue({ date: dayjs() });
                }}
              >
                Reset
              </Button>
            </Space>
          </Form.Item>
        </Form>
      </Card>

      {/* Expenses List */}
      <Card
        title={
          <Space>
            <Title level={4} style={{ margin: 0 }}>
              Expense Records
            </Title>
            <Tag color="blue">{pagination.total} Total</Tag>
          </Space>
        }
      >
        {/* Search and Filter Section */}
        <Row gutter={16} style={{ marginBottom: 16 }}>
          <Col xs={24} sm={12} md={8}>
            <Input.Search
              placeholder="Search by expense name..."
              allowClear
              enterButton={<SearchOutlined />}
              size="large"
              onSearch={handleSearch}
              onChange={(e) => {
                if (!e.target.value) {
                  handleSearch('');
                }
              }}
              value={searchText}
            />
          </Col>
          <Col xs={24} sm={12} md={10}>
            <RangePicker
              style={{ width: '100%' }}
              size="large"
              format="DD/MM/YYYY"
              value={dateRange}
              onChange={handleDateRangeChange}
              placeholder={['Start Date', 'End Date']}
            />
          </Col>
          <Col xs={24} sm={24} md={4}>
            <Space>
              <Button 
                icon={<ReloadOutlined />} 
                onClick={fetchExpenses}
                loading={tableLoading}
                size="large"
              >
                Refresh
              </Button>
              <Button 
                icon={<ClearOutlined />} 
                onClick={handleClearFilters}
                size="large"
                disabled={!searchText && !dateRange[0] && !dateRange[1] && Object.keys(filters).length === 0}
              >
                Clear
              </Button>
            </Space>
          </Col>
        </Row>

        {/* Active Filters Display */}
        {(searchText || dateRange[0] || Object.keys(filters).length > 0) && (
          <div style={{ marginBottom: 16 }}>
            <Space wrap>
              <Text strong>Active Filters:</Text>
              {searchText && (
                <Tag 
                  closable 
                  onClose={() => handleSearch('')}
                  color="blue"
                >
                  Search: {searchText}
                </Tag>
              )}
              {dateRange[0] && dateRange[1] && (
                <Tag 
                  closable 
                  onClose={() => handleDateRangeChange(null)}
                  color="green"
                >
                  Date: {dateRange[0].format('DD/MM/YYYY')} - {dateRange[1].format('DD/MM/YYYY')}
                </Tag>
              )}
              {filters.category && (
                <Tag color="orange">
                  Category: {filters.category}
                </Tag>
              )}
              {filters.paymentMode && (
                <Tag color="purple">
                  Payment: {filters.paymentMode}
                </Tag>
              )}
            </Space>
          </div>
        )}

        <Table
          columns={columns}
          dataSource={expenses}
          rowKey="_id"
          loading={tableLoading}
          pagination={{
            current: pagination.current,
            pageSize: pagination.pageSize,
            total: pagination.total,
            showTotal: (total) => `Total ${total} expenses`,
            showSizeChanger: true,
            pageSizeOptions: ['10', '20', '50', '100'],
          }}
          onChange={handleTableChange}
          scroll={{ x: 1200 }}
        />
      </Card>

      {/* View Modal */}
      <Modal
        title="Expense Details"
        open={viewModalVisible}
        onCancel={() => setViewModalVisible(false)}
        footer={[
          <Button key="close" onClick={() => setViewModalVisible(false)}>
            Close
          </Button>,
        ]}
        width={700}
      >
        {selectedExpense && (
          <div>
            <Row gutter={[16, 16]}>
              <Col span={12}>
                <strong>Expense Name:</strong>
                <div style={{ marginTop: 8 }}>{selectedExpense.expenseName}</div>
              </Col>
              <Col span={12}>
                <strong>Category:</strong>
                <div style={{ marginTop: 8 }}>
                  <Tag color={getCategoryColor(selectedExpense.category)}>
                    {selectedExpense.category}
                  </Tag>
                </div>
              </Col>
              <Col span={12}>
                <strong>Date:</strong>
                <div style={{ marginTop: 8 }}>
                  {dayjs(selectedExpense.date).format('DD/MM/YYYY')}
                </div>
              </Col>
              <Col span={12}>
                <strong>Amount:</strong>
                <div style={{ marginTop: 8, fontSize: 18, color: '#1890ff' }}>
                  ₹{selectedExpense.amount.toLocaleString('en-IN')}
                </div>
              </Col>
              <Col span={12}>
                <strong>Payment Mode:</strong>
                <div style={{ marginTop: 8 }}>
                  <Tag color={getPaymentModeColor(selectedExpense.paymentMode)}>
                    {selectedExpense.paymentMode}
                  </Tag>
                </div>
              </Col>
              <Col span={24}>
                <Divider />
                <strong>Notes / Description:</strong>
                <div style={{ marginTop: 8, whiteSpace: 'pre-wrap' }}>
                  {selectedExpense.notes || 'No notes available'}
                </div>
              </Col>
              {selectedExpense.attachments && selectedExpense.attachments.length > 0 && (
                <Col span={24}>
                  <Divider />
                  <strong>Attachments:</strong>
                  <div style={{ marginTop: 12 }}>
                    <Space direction="vertical" style={{ width: '100%' }}>
                      {selectedExpense.attachments.map((file, index) => (
                        <Card key={index} size="small">
                          <Space>
                            {file.fileType.startsWith('image/') ? (
                              <FileImageOutlined style={{ fontSize: 24, color: '#1890ff' }} />
                            ) : (
                              <FilePdfOutlined style={{ fontSize: 24, color: '#ff4d4f' }} />
                            )}
                            <div>
                              <div>{file.fileName}</div>
                              <a
                                href={file.fileUrl}
                                target="_blank"
                                rel="noopener noreferrer"
                                style={{ fontSize: 12 }}
                              >
                                View File
                              </a>
                            </div>
                          </Space>
                        </Card>
                      ))}
                    </Space>
                  </div>
                </Col>
              )}
            </Row>
          </div>
        )}
      </Modal>
    </div>
  );
};

export default AddExpensePage;